import {
  OverlayProps as MantineOverlayProps,
  Overlay as MantineOverlay,
} from '@mantine/core';

export type OverlayProps = MantineOverlayProps;

export const Overlay = MantineOverlay as typeof MantineOverlay;

Overlay.displayName = 'Overlay';
